import axios from "axios";
import { attachRequestSecurity } from './hmacUtils'
const AUTH_STORAGE_KEYS = ['token', 'user', 'id', 'uData'];

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;


export const clearAuthAndRedirect = () => { 
  AUTH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key)); 
  if (window.location.pathname !== '/adminlogin') { 
    window.location.assign('/adminlogin'); 
  } 
};

export const apiRequest = async (endpoint, method, data = null, headers = {}) => {
  const url = `${API_BASE_URL}/${endpoint}`;

  const options = {
    url,
    method: method,
    headers: {
      ...(data instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...headers,
    },
  };

  if (data) {
    options.data = data;
  }

  attachRequestSecurity(options);

  try {
    const response = await axios(options);

    if (!response) {
      throw new Error(`Error: ${response.status}`);
    }

    return response;
  } catch (error) {
     const status = error.response?.status;
        const isAuthEndpoint = String(endpoint).includes('admin/login') || String(endpoint).includes('login');
        if (status === 401 && !isAuthEndpoint) { 
          clearAuthAndRedirect(); 
        } 
        console.error("API request failed:", error); 
    throw error;
  }
};
